<template>
  <v-card class="filter-panel" elevation="0">
    <h1 class="filter-title">Filtrar Partes de Proceso</h1>
    <v-form class="filter-form" @submit.prevent="applyFilter" @keydown.enter.prevent="applyFilter">
      <v-row dense align="center">
      <v-col cols="12" sm="4" md="3">
        <v-text-field
          v-model="filters.processNumber"
          label="Nro. de parte"
          type="number"
          clearable
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="filters.referenceName"
          label="Nombre de referencia"
          clearable
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <v-select
          v-model="filters.status"
          :items="statusOptions"
          label="Estado"
          clearable
          hide-details
        />
      </v-col>
      </v-row>
      <div class="filter-actions">
        <v-btn color="secondary" variant="tonal" type="button" @click="clearFilter">
          Limpiar filtros
        </v-btn>
        <v-btn color="primary" type="submit">
          Filtrar
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { PROCESS_STATUS_OPTIONS } from '../../services/process/ProcessStatus'

const emptyFilters = () => ({
  processNumber: null,
  referenceName: '',
  status: null
})

export default {
  name: 'FilterProcessForm',
  data: () => ({
    filters: emptyFilters(),
    statusOptions: PROCESS_STATUS_OPTIONS
  }),
  methods: {
    applyFilter () {
      this.$store.dispatch('processModule/filterItems', this.filters)
    },
    clearFilter () {
      this.filters = emptyFilters()
      this.$store.dispatch('processModule/refreshFilteredProcesses')
    }
  }
}
</script>
